// extracted by mini-css-extract-plugin
export default {"locationForm":"LocationSection_locationForm__zW5Tw"};